// extracted by mini-css-extract-plugin
module.exports = {"aigcSwitch":"pv0J0UID","aigcSwitchText":"hjD0d4gZ","disabled":"mjDejvTl","aigcTip":"rvy6aYIM"};